import _ from 'lodash';
import { arrayAny } from '../../utils/arrayUtils';
import ObjectID from 'bson-objectid';

class KanbanFunctions {

    static projectColumnsInOrder = (data, boardId) => {

        if (arrayAny(data)) {
            const board = data.find(b => b.id === boardId);
            return this.columnsInOrder(board.columns);
        }

        return data;
    }

    static columnsInOrder = (columns) => {

        if (arrayAny(columns)) {
            return _.orderBy(columns ?? [], c => c.displayOrder, ['asc']);
        }

        return columns;
    }

    static pullProjectNames = (data) => {
        return _.map(data, p => { return { id: p.id, name: p.name }; });
    }

    static getRandomId = () => {
        return new ObjectID().toHexString();
    };

    static getFirstColumn = (columns) => {
        const firstColumn = _.first(_.filter(columns, col => col.displayOrder === 0));
        return firstColumn;
    };

    static getTasksForColumnFromTemplateTasks = (column, data) => {

        let result = [];

        if (arrayAny(data)) {
            const template = _.find(data, d => d.displayOrder === column.displayOrder);
            if (template) {

                const tasks = template.items;

                for (const st of tasks) {
                    let clone = Object.assign({}, st);
                    clone.id = this.getRandomId();
                    result.push(clone);
                }
            }
        }

        return result;
    };

    static getTasksForColumn = (column, template) => {

        let result = [];

        if (!template) {
            return result;
        }

        if (template && arrayAny(template.subTasks)) {

            const columnForTasks = _.filter(template.subTasks, st => st.columnName === column.id);
            const items = _.flatMap(columnForTasks, st => st.items)

            for (const st of items) {
                let clone = Object.assign({}, st);
                clone.id = this.getRandomId();
                result.push(clone);
            }
        }

        return result;
    };

    static addMissingSubTasks(currentSubTasks, newColumnSubTasks) {

        for (const t of newColumnSubTasks) {

            let exists = false;

            for (const tmt of currentSubTasks) {
                if (tmt.subTaskId === t.subTaskId) {
                    exists = true;
                }
            }

            if (!exists) {
                t.id = this.getRandomId();
                currentSubTasks.push(t);
            }
        }
    };

    static completeAutoCompleteSubTasks(currentSubTasks, arrayOfSubTaskIdsToComplete) {

        for (const subTask of currentSubTasks) {
            let shouldComplete = arrayAny(_.filter(arrayOfSubTaskIdsToComplete, id => { return subTask.subTaskId === id; }));
            if (shouldComplete) {
                subTask.complete = true;
            }
        }
    }

    static getDueDatesAsCalendarItems = (projects) => {

        let result = [];

        for (const project of projects) {

            // Get a flattened array of all items with a due date
            let items = _.filter(_.flatMap(project.columns, d => d.items), item => item.dueDate) ?? [];

            let newItems = _.map(items, item => {
                return {
                    id: item.id,
                    allDay: true,
                    title: item.name,
                    start: item.dueDate,
                    color: '#00ACAC',
                    extendedProps: { eventType: "kanban", project: project.id }
                };
            });

            result = [].concat(result, newItems);

        }

        return result;
    }

}

export default KanbanFunctions;